export default __webpack_public_path__ + "bc2539a832d04a584a521ee0bbc5e253.png";